import React from "react";
import { Link } from "react-router-dom";
import { getWhatsAppUrl, TRAINERS } from "../config/contact";
import logo from "../images/logoTheCrew.svg";
import "../blocks/Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <img src={logo} alt="THE CREW Personal Trainers" />
        <p>Entrenamiento personal para recuperar fuerza y capacidad física a partir de los 40.</p>
      </div>
      <div className="site-footer__contacts">
        <p>Habla directamente con el equipo</p>
        <a href={getWhatsAppUrl(TRAINERS.juanCarlos)} target="_blank" rel="noreferrer"><span>Juan Carlos</span><span>{TRAINERS.juanCarlos.phone} ↗</span></a>
        <a href={getWhatsAppUrl(TRAINERS.xavi)} target="_blank" rel="noreferrer"><span>Xavi</span><span>{TRAINERS.xavi.phone} ↗</span></a>
      </div>
      <div className="site-footer__bottom">
        <address>C/ Cardenal Rossell, 20 · 07007 Palma, Mallorca</address>
        <Link to="/privacy">Privacidad</Link>
        <small>© {new Date().getFullYear()} THE CREW</small>
      </div>
    </footer>
  );
}

export default Footer;
